import { useEffect } from 'react';

/**
 * Componente SEO para gestionar meta tags Open Graph y otros meta tags
 * @param {Object} props
 * @param {string} props.title - Título de la página
 * @param {string} props.description - Descripción de la página
 * @param {string} props.image - URL de la imagen para compartir
 * @param {string} props.url - URL de la página
 * @param {string} props.type - Tipo de contenido (default: 'website')
 */
const SEO = ({
    title,
    description,
    image,
    url,
    type = 'website'
}) => {
    useEffect(() => {
        /**
         * Actualiza o crea un meta tag
         */
        const updateMetaTag = (attribute, name, content) => {
            if (!content) return;

            let element = document.querySelector(`meta[${attribute}="${name}"]`);
            if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attribute, name);
                document.getElementsByTagName('head')[0].appendChild(element);
            }
            element.setAttribute('content', content);
        };

        // Construir URLs absolutas
        const siteUrl = process.env.REACT_APP_SITE_URL || window.location.origin;
        const absoluteUrl = url ? new URL(url, siteUrl).href : window.location.href;
        const absoluteImage = image ? new URL(image, siteUrl).href : `${siteUrl}/og-image.svg`;

        // Título
        const originalTitle = document.title;
        if (title) {
            document.title = title;
        }

        // Meta description
        updateMetaTag('name', 'description', description);

        // Open Graph tags
        updateMetaTag('property', 'og:title', title);
        updateMetaTag('property', 'og:description', description);
        updateMetaTag('property', 'og:image', absoluteImage);
        updateMetaTag('property', 'og:url', absoluteUrl);
        updateMetaTag('property', 'og:type', type);
        updateMetaTag('property', 'og:site_name', 'Heaful');

        // Twitter Card tags
        updateMetaTag('name', 'twitter:card', 'summary_large_image');
        updateMetaTag('name', 'twitter:title', title);
        updateMetaTag('name', 'twitter:description', description);
        updateMetaTag('name', 'twitter:image', absoluteImage);

        // Cleanup: restaurar el título original al desmontar
        return () => {
            document.title = originalTitle;
        };
    }, [title, description, image, url, type]);

    return null;
};

export default SEO;

